<template>
  <v-row>
    <v-col cols="12" md="9" class="pr-md-5">
      <slot name="filter" />
    </v-col>
    <v-col cols="12" md="3" class="mb-xs-5 mb-sm-5" v-if="canCreate">
      <BaseButton
        class="secondary text-uppercase subtitle-2 font-weight-bold"
        :to="{ name: 'new economic_group' }"
        style="width: 100%"
      >
        <v-icon class="pr-4 add-icon">fa-plus</v-icon>
        Adicionar Grupo
      </BaseButton>
    </v-col>
    <v-col cols="12">
      <slot />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "EconomicGroupTab",
  props: {
    canCreate: {
      type: Boolean
    }
  }
};
</script>
